import React from 'react';
import { humanize } from '@utils';
import { getMetricUnit } from '@utils/metrics';
import { APP_DIMENSIONS } from '@utils/dimension/appDimensionHelper';

export const getDimensionDetail = (dimension: string, dimensionList: Record<string, any>[]) => {
  const dimensionDetails = dimensionList.find((d) => d.groupBy === dimension)!;
  return dimensionDetails;
};

export const getDimensionNames = (dimensions: string[], dimensionList: Record<string, any>[]) => {
  return dimensions.map((it) => getDimensionDetail(it, dimensionList).name);
};

export const RECORD_KEYS = {
  ENCODED_STACK_TRACE: APP_DIMENSIONS.STRACK_TRACE,
  DECODED_STACK_TRACE: APP_DIMENSIONS.STRACK_TRACE + '__decoded',
} as const;

export const getStackTraceFromData = (data: Record<string, any>) => {
  const text = data.isDecoded
    ? data[RECORD_KEYS.DECODED_STACK_TRACE]
    : data[RECORD_KEYS.ENCODED_STACK_TRACE];
  return text;
};

export const getColumns = (
  columns: any,
  dimensions: string[],
  dimensionList: Record<string, any>[],
) => {
  const dimensionsColumns = dimensions.map((it, idx) => {
    const isStackTrace = it === RECORD_KEYS.ENCODED_STACK_TRACE;
    return {
      title: getDimensionDetail(it, dimensionList).name,
      dataIndex: it,
      key: it,
      ellipsis: true,
      width: idx === 0 ? (dimensions.length === 1 ? '400px' : '300px') : '100px',
      render: (_, record) => {
        if (isStackTrace) {
          const text = getStackTraceFromData(record);
          return <span>{text}</span>;
        } else {
          return <span>{record[it]}</span>;
        }
      },
    };
  });
  const metricsColumns = [] as any;
  columns.forEach((column) => {
    const { key } = column;
    if (key === 'action' || dimensions.includes(key)) return;
    metricsColumns.push({
      title: column.title,
      dataIndex: key,
      key,
      ellipsis: true,
      width: '100px',
      sorter: (a: any, b: any) => {
        if (a[key] === 'NA' || b[key] === 'NA') {
          return 0;
        }
        return a[key] - b[key];
      },
      render: (text: string) => {
        const metricUnit = getMetricUnit({ metricKey: key });
        return <span>{text !== 'NA' ? humanize(text, metricUnit) : 'NA'}</span>;
      },
    });
  });

  return [...dimensionsColumns, ...metricsColumns];
};
